import * as classNames from "classnames";
import * as moment from "moment";
import * as React from "react";
import * as DTOS from "../../../../FeralScan.dtos";
import Select from "./Select";
import { controlColumnClass, labelColumnClass } from "../consts";

export type MonthYearProps = {
    className?: string,
    controlOrder: 'monthyear' | 'yearmonth',
    defaultDay: string,
    mandatory: boolean,
    month: string,
    name: string,
    questionIndex: number,
    readOnly: boolean,
    year: string,

    //react-redux-form controls these
    touched?: boolean,
    valid?: boolean
};

export type MonthYearActions = {
    onBlur(): void,
    onChange(date: string): void,
    onFocus(): void
};

export type MonthYearPropsAndActions = MonthYearProps & MonthYearActions;

class MonthYear extends React.PureComponent<MonthYearPropsAndActions, any> {
    render() {
        let yearOptions: DTOS.QuestionOption[] = [];

        /* Add last 5 years */
        for (let i = 0; i < 5; i++) {
            let year = moment(Date.now()).year() - i;
            yearOptions.push({
                type: "QUESTION_OPTION",
                value: year.toString(),
                label: year.toString(),
                rank: i + 1,
                optionId: undefined,
                questions: undefined
            });
        }

        const monthOptions: DTOS.QuestionOption[] = [
            {
                type: "QUESTION_OPTION",
                value: "01",
                label: "January",
                rank: 1,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "02",
                label: "February",
                rank: 2,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "03",
                label: "March",
                rank: 3,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "04",
                label: "April",
                rank: 4,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "05",
                label: "May",
                rank: 5,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "06",
                label: "June",
                rank: 6,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "07",
                label: "July",
                rank: 7,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "08",
                label: "August",
                rank: 8,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "09",
                label: "September",
                rank: 9,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "10",
                label: "October",
                rank: 10,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "11",
                label: "November",
                rank: 11,
                optionId: undefined,
                questions: undefined
            },
            {
                type: "QUESTION_OPTION",
                value: "12",
                label: "December",
                rank: 12,
                optionId: undefined,
                questions: undefined
            }
        ];

        const monthElement = <div className={classNames(this.props.className, controlColumnClass)}>
            {/* Month */}
            <Select
                className={classNames(
                    "form-control",
                    {
                        "form-control-success":
                            this.props.valid && this.props.touched && !this.props.readOnly
                    },
                    {
                        "form-control-danger":
                            !this.props.valid && this.props.touched && !this.props.readOnly
                    }
                )}
                readOnly={this.props.readOnly}
                onBlur={(event: React.FocusEvent<HTMLSelectElement>) => {
                    this.props.onBlur()
                }}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                    this.props.onChange(`${this.props.defaultDay}/${event.target.value}/${this.props.year}`)
                }}
                onFocus={(event: React.FocusEvent<HTMLSelectElement>) => {
                    this.props.onFocus()
                }}
                value={this.props.month}
            >
                <option value="-1"></option>
                {monthOptions ?
                    monthOptions.map((option, i) => {
                        return (
                            <option
                                key={`questions.${this.props.questionIndex}.Month.option.${i}`}
                                value={option.value}
                            >
                                {option.label}
                            </option>
                        );
                    })
                    : undefined}
            </Select>
        </div>;

        const yearElement = <div className={classNames(this.props.className, controlColumnClass)}>
            {/* Year */}
            <Select
                className={classNames(
                    "form-control",
                    {
                        "form-control-success":
                            this.props.valid && this.props.touched && !this.props.readOnly
                    },
                    {
                        "form-control-danger":
                            !this.props.valid && this.props.touched && !this.props.readOnly
                    }
                )}
                readOnly={this.props.readOnly}
                onBlur={(event: React.FocusEvent<HTMLSelectElement>) => {
                    this.props.onBlur()
                }}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                    this.props.onChange(`${this.props.defaultDay}/${this.props.month}/${event.target.value}`)
                }}
                onFocus={(event: React.FocusEvent<HTMLSelectElement>) => {
                    this.props.onFocus()
                }}
                value={this.props.year}
            >
                <option value="-1"></option>
                {yearOptions ?
                    yearOptions.map((option, i) => {
                        return (
                            <option
                                key={`questions.${this.props.questionIndex}.Year.option.${i}`}
                                value={option.value}
                            >
                                {option.label}
                            </option>
                        );
                    })
                    : undefined}
            </Select>
        </div>;

        const firstElement = this.props.controlOrder === 'monthyear' ?
            monthElement :
            yearElement;

        const secondElement = this.props.controlOrder === 'monthyear' ?
            yearElement :
            monthElement; 

        return <div>
            <div className="row pb-3">
                <label className={classNames("lead my-0", labelColumnClass)}>{this.props.name.split("|")[0]}</label>
                {firstElement}
            </div>
            <div className="form-divider">
            </div>
            <div className="row mt-3 mb-3">
                <label className={classNames("lead", labelColumnClass)}>{this.props.name.split("|")[1]}</label>
                {secondElement}
            </div>
        </div>;
    }
}

export default MonthYear;